import Component from '@glimmer/component';
import ContactListItemButton from './contact-list-item/item-button.gjs';
import ContactListItemContent from './contact-list-item/item-content.gjs';
import ContactListItemReadOnly from './contact-list-item/item-read-only.gjs';

export default class ContactListItem extends Component {
  get userNames() {
    return this.args.contact?.members?.map(user => user.name).join(' & ') ?? '';
  }

  get isInteractive() {
    return typeof this.args.onSelect === 'function';
  }

  get isNotPermitted() {
    return this.args.contact?.permitted === false;
  }

  get containerClass() {
    if (this.isInteractive) {
      return ContactListItemButton;
    } else {
      return ContactListItemReadOnly;
    }
  }

  handleClick = () => {
    if (this.args.onSelect) {
      this.args.onSelect(this.args.contact);
    }
  };

  <template>
    <this.containerClass
      @contactId={{@contact.id}}
      @isDisabled={{this.isNotPermitted}}
      @onClick={{this.handleClick}}
      @userNames={{this.userNames}}
      inert={{@inert}}
    >
      <ContactListItemContent
        @contact={{@contact}}
        @groupMessagingEnabled={{@groupMessagingEnabled}}
        @isNotPermitted={{this.isNotPermitted}}
        @userNames={{this.userNames}}
      />
    </this.containerClass>
  </template>
}
